(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bachans-story-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bachans-story-video')) {
    customElements.define('bachans-story-video', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.bachans-story-hero__poster');
        const player = this.querySelector('.bachans-story-hero__player');
        const template = this.querySelector('template');
        if (!button || !player || !template) return;
        button.addEventListener('click', () => {
          player.replaceChildren(template.content.cloneNode(true));
          const iframe = player.querySelector('iframe');
          if (iframe) {
            iframe.title = this.dataset.videoTitle || "The Story Behind Bachan's";
            iframe.loading = 'eager';
          }
          player.hidden = false;
          button.hidden = true;
          if (iframe) iframe.focus();
        }, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
